import { toast } from "@risalabs_frontend_org/oasis-ui-kit";
import { useState } from "react";
import { Select } from "risa-oasis-ui_v2";
import DragDropUpload from "../../../../../../components/dragDropUpload/dragDropUpload";
import InlineLoaderWithMessage from "../../../../../../components/inlineLoaderWithMessage/inlineLoaderWithMessage";
import { ToastMessages } from "../../../../../../components/toasts/toastMessages";
import { useHealthCareFacilities } from "../../../../../../hooks/useHealthCareFacilities";
import DownloadIcon from "../../../../../../svg/download-icon";
import { getOrgIdForFetchExternalWorklist } from "../../../../../../utils/organizationHelper";
import { handleDownload } from "./utils/handleDownload";

const ProviderList = () => {
  const [uploadedFileName, setUploadedFileName] = useState<string | null>(null);
  const [isDownloading, setIsDownloading] = useState(false);
  const [selectedHealthCareFacility, setSelectedHealthCareFacility] =
    useState<string>(getOrgIdForFetchExternalWorklist());
  const { healthCareFacilities, healthCareFacilityOptions } =
    useHealthCareFacilities();

  const handleFileUpload = (urls: string[]) => {
    if (urls.length > 0 && urls[0].trim() !== "") {
      setUploadedFileName("Provider_List.xlsx");
      toast.success(ToastMessages.PROVIDER_LIST_UPLOAD_SUCCESS);
    }
  };

  return (
    <div className="pharma-pa-configuration__provider-list h-full w-full bg-primaryGray-16 p-4">
      <div className="pharma-pa-configuration__provider-list-inner-container flex h-full flex-col gap-6 overflow-hidden rounded-lg bg-white p-6">
        {/* Header Section */}
        <div className="pharma-pa-configuration__provider-list-header border-b border-primaryGray-16 pb-4">
          <h1 className="text-h11 font-bold text-primaryGray-1">
            Provider List
          </h1>
        </div>

        {/* Main Content Section */}
        <div className="pharma-pa-configuration__provider-list-content flex flex-1 flex-col gap-6">
          {/* Download Section */}
          <div className="provider-list__download-section flex flex-col gap-3">
            <div className="text-h12 font-semibold text-primaryGray-1">
              Download Provider List
            </div>
            <div className="flex items-center justify-between gap-3">
              <div className="select-organization">
                {healthCareFacilities.loading ? (
                  <InlineLoaderWithMessage message="Loading..." />
                ) : (
                  <Select
                    id={"organization-select"}
                    onOptionChange={(data) =>
                      setSelectedHealthCareFacility(data.value)
                    }
                    label={""}
                    defaultValue={selectedHealthCareFacility}
                    placeholder={"Select Organization"}
                    options={healthCareFacilityOptions}
                  />
                )}
              </div>
              <div className="download-button-provider-list flex gap-2">
                {isDownloading ? (
                  <InlineLoaderWithMessage message="Downloading..." />
                ) : (
                  <div
                    className="download-button flex items-center gap-2"
                    onClick={() =>
                      handleDownload(
                        selectedHealthCareFacility,
                        setIsDownloading,
                      )
                    }
                  >
                    <DownloadIcon />
                    <span className="text-small font-semibold text-tertiaryBlue-4 hover:cursor-pointer hover:text-tertiaryBlue-4/80">
                      Download Excel
                    </span>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Upload Section */}
          <div className="provider-list__upload-section flex flex-col gap-3">
            <div className="text-h12 font-semibold text-primaryGray-1">
              Upload Provider List
            </div>
            <div className="flex flex-col gap-3">
              <DragDropUpload
                id="provider-list-upload"
                subText="Supported file format .xlsx not exceeding 10MB"
                multipleFilesAllowed={false}
                maxFileSize={10 * 1024 * 1024}
                downloadedURL={handleFileUpload}
                allowedFileTypes={[".xlsx"]}
                filePath={`payer-utils/${selectedHealthCareFacility}/Provider_List.xlsx`}
              />
              {uploadedFileName && (
                <div className="text-small text-primaryGray-4">
                  Last uploaded: {uploadedFileName}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProviderList;
